<template>
    <section class="header_xtype header_main font-responsive">
        <div class="header_kv w-full r-8/3">
            <img :src="component_data.params.img.src" :alt="component_data.params.img.alt">
        </div>
        <video-block class="feat_video" v-if="component_data.params.vid" :component_data="component_data.params.vid"> </video-block>
        <div class="header_content mobile-sides">
            <div class="feat_texts">
                <p v-for="(text, index) in texts(component_data.params)" v-html="text" :key="index"></p>
            </div>
        </div>
    </section>
</template>

<script>
import video from '@/components/videoBlock/video'
export default {
    props: ['component_data'],
    components: {
        "video-block": video
    }
}
</script>

<style scoped>
    .header_kv {
        position: relative;
    }
    .header_kv img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0; left: 0;
        object-fit: cover;
    }
    .header_xtype {
        position: relative;
    }
    .header_xtype .feat_video {
        width: 26vw;
        height: 15.6vw;
        left: initial;
        right: 7.8vw;
        bottom: -6em;
        box-shadow: 0 20px 20px -15px rgba(125,6,11,.8);
        position: absolute;
    }

    .header_xtype .feat_video::before {
        display: none;
    }
</style>
<style>
    .header_xtype .feat_video .avc_thumb{
        border-radius: 0;
        border-top-right-radius: 6em;
    }
</style>
